import {
  useRecordContext,
  Confirm,
  useSaveContext,
  SaveButton,
  useNotify,
} from "react-admin";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useMyContext } from "./myContext";
import pick from "lodash/pick";

export const ConfirmAndSaveButton = ({
  confirmMessage,
  showDialog = (_record, _valuesToSave) => false,
}) => {
  const notify = useNotify();
  const { save, saving, mutationOptions } = useSaveContext(); // React Admin’s native save()
  const { getValues } = useFormContext();
  const { mutatorSources } = useMyContext() || [];

  const record = useRecordContext(); // Current record before editing

  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(null);

  const handleClick = (event) => {
    event.preventDefault();

    const newValues = getValues();

    let valuesToSave = newValues;
    if (mutationOptions?.onMutate) {
      try {
        valuesToSave = mutationOptions.onMutate(newValues);
      } catch (error) {
        notify(`Error de validación: ${error.message}`, { type: "warning" });
        return;
      }
    }
    if (mutatorSources.length) {
      valuesToSave = pick(valuesToSave, mutatorSources);
    }

    if (showDialog(record, valuesToSave)) {
      setValues(valuesToSave);
      setOpen(true);
    } else {
      save(valuesToSave);
    }
  };

  const handleConfirm = () => {
    setOpen(false);
    save(values); // proceed with normal RA save logic
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  return (
    <>
      <SaveButton label="Save" saving={saving} onClick={handleClick} />

      <Confirm
        isOpen={open}
        title="WARNING! READ THIS"
        content={confirmMessage}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
        sx={{
          "*": {
            paddingBottom: "5px",
          },
        }}
        confirm={"YES"}
        cancel={"NO"}
        confirmColor="green"
      />
    </>
  );
};
